import { render, staticRenderFns } from "./CreateKlaimPd.vue?vue&type=template&id=1bcad26c&scoped=true&"
import script from "./CreateKlaimPd.vue?vue&type=script&lang=js&"
export * from "./CreateKlaimPd.vue?vue&type=script&lang=js&"
import style0 from "./CreateKlaimPd.vue?vue&type=style&index=0&id=1bcad26c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcad26c",
  null
  
)

export default component.exports